export const FADE_IN_ANIMATION_SETTINGS = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  transition: { duration: 0.2 },
};

export const FADE_DOWN_ANIMATION_VARIANTS = {
  hidden: { opacity: 0, y: -10 },
  show: { opacity: 1, y: 0, transition: { type: "spring" } },
};

export const FADE_UP_ANIMATION_VARIANTS = {
  hidden: { opacity: 0, y: 10 },
  show: { opacity: 1, y: 0, transition: { type: "spring" } },
};

export const MAIN_SITE_URL = "https://rent.today";

export const categories = [
  {
    label: "Income",
    value: "income",
    subcategories: [
      { label: "Rental Income", value: "rental_income" },
      { label: "Section 8 Rents", value: "section_8_rents" },
      { label: "Short Term Rents", value: "short_term_rents" },
      { label: "Application Fees", value: "application_fees" },
      { label: "Late Fees Collected", value: "late_fees" },
      { label: "Pet Fees", value: "pet_fees" },
      { label: "Laundry", value: "laundry" },
      { label: "Storage", value: "storage" },
      { label: "Parking", value: "parking" },
      { label: "Tenant Pass-Throughs", value: "tenant_pass_throughs" },
      { label: "Misc Interest", value: "misc_interest" },
      { label: "Insurance Proceeds", value: "insurance_proceeds" },
      { label: "Cleaning & Other Upsells", value: "cleaning_other_upsells" },
      { label: "Other Rental Income", value: "other_income" },
    ],
  },
  {
    label: "Expenses",
    value: "expenses",
    subcategories: [
      { label: "Advertising", value: "advertising" },
      { label: "Auto and Travel", value: "auto_travel" },
      { label: "Cleaning and Maintenance", value: "cleaning_maintenance" },
      { label: "Commissions", value: "commissions" },
      { label: "Insurance", value: "insurance" },
      { label: "Legal and Professional Fees", value: "legal_professional" },
      { label: "Management Fees", value: "management_fees" },
      { label: "Mortgage", value: "mortgage" },
      { label: "Mortgage Interest", value: "mortgage_interest" },
      { label: "Repairs", value: "repairs" },
      { label: "Supplies", value: "supplies" },
      { label: "Taxes", value: "taxes" },
      { label: "Utilities", value: "utilities" },
      { label: "Other Expenses", value: "other_expenses" },
    ],
  },
  {
    label: "Capital Expenditures",
    value: "capital_expenditures",
    subcategories: [
      { label: "Appliances", value: "appliances" },
      { label: "Furniture", value: "furniture" },
      { label: "Renovations", value: "renovations" },
      {
        label: "HVAC / Plumbing / Electrical",
        value: "hvac_plumbing_electrical",
      },
      { label: "Roof Replacement", value: "roof_replacement" },
      { label: "Fencing / Landscaping", value: "fencing_landscaping" },
      { label: "Driveways and Sidewalks", value: "driveways_sidewalks" },
      { label: "Security Systems", value: "security_systems" },
    ],
  },
  {
    label: "Transfer",
    value: "transfer",
    subcategories: [
      { label: "Security Deposit", value: "security_deposit" },
      { label: "Credit Card Payments", value: "credit_card_payments" },
      { label: "Owner Distributions", value: "owner_distributions" },
      { label: "Owner Contributions", value: "owner_contributions" },
      { label: "General Escrow Payments", value: "general_escrow_payments" },
      { label: "Property Tax Escrows", value: "property_tax_escrows" },
      { label: "Insurance Escrows", value: "insurance_escrows" },
      { label: "PMI Escrows", value: "pmi_escrows" },
      { label: "HOA Escrows", value: "hoa_escrows" },
      { label: "Down Payments", value: "down_payments" },
      { label: "Sale Proceeds", value: "sale_proceeds" },
      { label: "Taxes to Remit", value: "taxes_to_remit" },
    ],
  },
];
